<template>
  <a class="copy-link" :class="rootClass" @click.stop="copyCrmNo" @keyup.space="copyCrmNo"  v-tooltip="$t('adm.button.copy')">
    <img src="@/assets/img/icons/copy.svg" :alt="$t('adm.button.copy')" :class="iconClass">
  </a>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CopyPasta',
  props: {
    data: { type: String, default: null },
    rootClass: { type: String, default: '' },
    iconClass: { type: String, default: '' },
  },
  methods: {
    async copyCrmNo() {
      if (this.data) {
        navigator.clipboard.writeText(this.data).then(() => {
          this.$toast.success(this.$t('adm.page.organization.infoCopied', [this.data]));
        });
      }
    },
  },
});
/* generate svg color-filter with: https://codepen.io/sosuke/pen/Pjoqqp */
</script>

<style>
.copy-link {
  cursor: pointer;
  filter: invert(96%) sepia(0%) saturate(7419%) hue-rotate(67deg) brightness(96%) contrast(83%);
}
.copy-link:hover {
  filter: invert(8%) sepia(4%) saturate(448%) hue-rotate(314deg) brightness(100%) contrast(85%);
}
.copy-link img{
  vertical-align: top;
}
</style>
